import {ALL_FIRST_DOWN_MARKETS} from '../constants/marketTypes';

export function getMarketsByCode(marketCode, markets) {
    let marketsByCode = [];
    if (marketCode && markets && markets.length) {
        for (let i = 0; i < markets.length; i++) {
            if (markets[i].id.substring(0, marketCode.code.length) === marketCode.code) {
                marketsByCode.push(markets[i]);
            }
        }
    }
    return marketsByCode;
}

export function areFirstDownMarketsExpanded(firstDownMarketsExpanded) {
    let expanded = true;

    if (firstDownMarketsExpanded && firstDownMarketsExpanded.length) {
        expanded = firstDownMarketsExpanded.find((mkt) => mkt === true);
    }
    return expanded;
}

export function getMarketById(id) {
    return ALL_FIRST_DOWN_MARKETS.filter((market) => market.ids.includes(id))[0];
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/firstDown/helpers/marketHelpers.js